import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import ProtectedRoute from "./components/ProtectedRoute";
import ModuleGate from "./components/ModuleGate";
import { AuthProvider } from "./lib/auth";
import { TrendProvider } from "./lib/trend";
import TrendAnalyzer from "./components/TrendAnalyzer";
import Overview from "./pages/Overview";
import Control from "./pages/Control";
import Identity from "./pages/Identity";
import SOC from "./pages/SOC";
import Firewall from "./pages/Firewall";
import WebGateway from "./pages/WebGateway";
import Vulnerabilities from "./pages/Vulnerabilities";
import Email from "./pages/Email";
import AISecurity from "./pages/AISecurity";
import CloudSecurity from "./pages/CloudSecurity";
import AssetManagement from "./pages/AssetManagement";
import Projects from "./pages/Projects";
import Support from "./pages/Support";
import Drill from "./pages/Drill";
import Login from "./pages/Login";
import Enroll2FA from "./pages/Enroll2FA";
import Admin from "./pages/Admin";
import ChangePassword from "./pages/ChangePassword";
import Connectors from "./pages/Connectors";

function Shell({ children }) {
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col bg-white">{children}</div>
    </div>
  );
}

const Guarded = ({ children, module, requireRoles }) => (
  <ProtectedRoute module={module} requireRoles={requireRoles}>
    <Shell><ModuleGate module={module}>{children}</ModuleGate></Shell>
  </ProtectedRoute>
);

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <TrendProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/account/password" element={<Guarded><ChangePassword /></Guarded>} />
              <Route path="/admin" element={<Guarded requireRoles={["super_admin", "org_admin"]}><Admin /></Guarded>} />
              <Route path="/connectors" element={<Guarded requireRoles={["super_admin", "org_admin"]}><Connectors /></Guarded>} />
              <Route path="/" element={<Guarded module="overview"><Overview /></Guarded>} />
              <Route path="/control" element={<Guarded module="control"><Control /></Guarded>} />
              <Route path="/identity" element={<Guarded module="identity"><Identity /></Guarded>} />
              <Route path="/soc" element={<Guarded module="soc"><SOC /></Guarded>} />
              <Route path="/firewall" element={<Guarded module="firewall"><Firewall /></Guarded>} />
              <Route path="/webgw" element={<Guarded module="webgw"><WebGateway /></Guarded>} />
              <Route path="/vuln" element={<Guarded module="vuln"><Vulnerabilities /></Guarded>} />
              <Route path="/email" element={<Guarded module="email"><Email /></Guarded>} />
              <Route path="/aisec" element={<Guarded module="aisec"><AISecurity /></Guarded>} />
              <Route path="/cloud" element={<Guarded module="cloud"><CloudSecurity /></Guarded>} />
              <Route path="/assets" element={<Guarded module="assets"><AssetManagement /></Guarded>} />
              <Route path="/projects" element={<Guarded module="projects"><Projects /></Guarded>} />
              <Route path="/support" element={<Guarded module="support"><Support /></Guarded>} />
              <Route path="/drill/:dataset" element={<Guarded><Drill /></Guarded>} />
              <Route path="/security/2fa" element={<Guarded><Enroll2FA /></Guarded>} />
            </Routes>
            <TrendAnalyzer />
          </TrendProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
